module.exports = __webpack_public_path__ + "img/b2.16dfe44c.jpg";